import React from 'react';
import { Breadcrumb, cn, Grid, Grid2, GridItem, TBreadcrumbContent, Typography } from '@riac/design-system';
import { sliderSizeClassName } from 'src/pages/FrontPage/FrontPageVideo';

export type TGenericPageHeaderProps = React.PropsWithChildren<{
  title: string | JSX.Element,
  titleClassName?: string,
  description?: JSX.Element | string,
  backgroundImage?: string,
  backgroundPosition?: string,
  addon?: JSX.Element
  backgroundOverlayClassName?: string;
  backgroundOverlayAddon?: JSX.Element;
  large?: boolean,
  breadcrumbs?: TBreadcrumbContent[];
  breadcrumbsAddon?: JSX.Element;
  titleAddon?: JSX.Element;
  titleAddonContainerClassName?: string;
  className?: string;
  gridClassName?: string;
  retainBackgroundOnSmallScreens?: boolean;
}>;

export const sliderSizeSmallClassName = 'min-w-full pt-[140px] pb-10';
export const sliderSizeLargeClassName = 'min-w-full min-h-[202px] md:min-h-[432px] xl:min-h-[742px]';

export const GenericPageHeader = (props: TGenericPageHeaderProps): JSX.Element => {
  const mainsection = <>
    <div className='flex flex-row gap-3 flex-wrap justify-between'>
      {props.breadcrumbs && <Breadcrumb
        content={props.breadcrumbs}
      />}
      {props.breadcrumbsAddon}
    </div>
    <div className='flex flex-col md:flex-row justify-between flex-wrap gap-6'>
      <div className='flex-1 flex flex-col max-w-[994px]'>
        <Typography
          tag='h1' size='lg' weight='semibold' expressive display
          className={cn('text-[#D7B054]', props.titleClassName)}
        >
          {props.title}
        </Typography>
        <div className='flex flex-col gap-6'>
          {props.description ? <Typography className='min-h-[56px]' color='text' size='lg'>
            {props.description}
          </Typography> : <div/>}
          {props.addon}
        </div>
      </div>
      {props.titleAddon && <div className={cn('flex-0', props.titleAddonContainerClassName)}>
        {props.titleAddon}
      </div>}
    </div>
  </>;
  return (<>
    <div className={cn('flex flex-col md:gap-5', props.className)}>
      <Grid2
        style={{
          backgroundImage: props.backgroundImage && `url(${props.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: props.backgroundPosition || 'center',
          backgroundRepeat: 'no-repeat',
        }}
        className={cn(
          props.large && sliderSizeLargeClassName || sliderSizeSmallClassName,
          'bg-neutral-100 pb-10',
          'pt-[121px]',
          props.retainBackgroundOnSmallScreens ? 'pt-[140px]' : '',
          'flex flex-col justify-stretch dark relative',
          props.gridClassName,
        )}
        innerContainerClassName={cn(
          'flex-1 w-full flex flex-col justify-end'
        )}
      >
        <div className={cn(
          'absolute top-0 left-0 w-full h-full z-0',
          props.backgroundOverlayClassName,
        )}>
          {props.backgroundOverlayAddon}
        </div>
        <div className={cn(
          'flex-col z-10 hidden md:flex gap-5 text-text-contrast-light',
          props.retainBackgroundOnSmallScreens ? 'flex' : '',
        )}>
          {mainsection}
        </div>
      </Grid2>
      <Grid2 className={cn(
        'md:hidden pb-10 pt-0 dark text-text bg-surface-dark',
        props.retainBackgroundOnSmallScreens ? 'hidden' : '',
        props.gridClassName
      )}>
        <div className='flex flex-col gap-5 text-text'>
          {mainsection}
        </div>
      </Grid2>
    </div>
  </>);
};
